import { JOBGROUP_FETCHING, JOBGROUP_FAILED, JOBGROUP_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOBGROUP_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOBGROUP_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOBGROUP_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
